/**
 * Keyboard helpers for custom **`role="button"`** surfaces (non-`<button>` elements with `tabindex="0"`).
 *
 * Matches native **`<button>`** behavior: **Enter** activates on **`keydown`**; **Space** activates on **`keyup`**
 * (so holding Space does not repeat-fire), with **`keydown` Space** calling **`preventDefault()`** to avoid scrolling the page.
 */

/**
 * Handles **`keydown`**: **Enter** runs `activate` once (skips {@link KeyboardEvent.repeat}); **Space** only scroll-blocks.
 * Pair with {@link cadsRoleButtonKeyup} on the same element.
 */
export function cadsRoleButtonKeydown(
  event: KeyboardEvent,
  isActive: boolean,
  activate: () => void,
): void {
  if (!isActive) {
    return;
  }
  if (event.key === ' ') {
    event.preventDefault();
    return;
  }
  if (event.key === 'Enter' && !event.repeat) {
    event.preventDefault();
    activate();
  }
}

/**
 * Handles **`keyup`** for **Space** only (skips {@link KeyboardEvent.repeat}). Call `activate` for a full press/release cycle.
 */
export function cadsRoleButtonKeyup(
  event: KeyboardEvent,
  isActive: boolean,
  activate: () => void,
): void {
  if (!isActive) {
    return;
  }
  if (event.key === ' ' && !event.repeat) {
    event.preventDefault();
    activate();
  }
}
